import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { toast } from 'react-toastify';

export const useBulkToggleOrganizationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'bulkToggleStatus'],
    mutationFn: async ({ ids, enable }: { ids: string[]; enable: boolean }) =>
      organizationService.setEnabledBulk(ids, enable),
    onSuccess: (count, { enable }) => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      const suffix = count === 1 ? 'organization' : 'organizations';
      toast.success(
        enable
          ? `${count} ${suffix} enabled`
          : `${count} ${suffix} disabled`,
      );
    },
    onError: (error: any) => {
      console.error('Bulk toggle organization status error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        error?.toString() ||
        'Failed to update organizations';
      toast.error(errorMessage);
    },
  });
};

export default useBulkToggleOrganizationStatus;
